import React, {Component} from 'react';

export default class Empty extends Component {
	render() {
		return (
			<article className={`card archive empty`}>
			</article>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/main/empty.js